export default {
  defaultApiVersion: "application/vnd.argo.v2+json",
  apiBaseURL: import.meta.env.VITE_APP_URL_BASE,
  timeout: 90000,
};
